/* gb-anim.js — homepage section reveal-on-scroll.
   Safe by design: this script ADDS the .gb-rv hidden state at runtime, so if the
   script never runs (no JS / error / reduced-motion) every section stays visible. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var secs = main.querySelectorAll(':scope > .shopify-section');
    if (!secs.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('gb-rv-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    secs.forEach(function (s) {
      // Hero has its own on-load entrance; never hide the announcement/header.
      if (s.querySelector('.gb-hero-split, .gb-announce')) return;
      s.classList.add('gb-rv');
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
